<div class="workshop-content">
    <h1 class="visually-hidden">My Workshops</h1>

    <div class="visually-hidden" role="status" aria-live="polite" aria-atomic="true" #liveRegion></div>

    <div class="container-fluid mt-4">
        <div class="row" id="main-content">
            <div class="col-xxl-1"></div>
            <div class="col-xxl-10">
                <!-- My Upcoming Workshops -->
                <div class="row g-4 mb-4">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col-12 col-md-10 d-flex align-items-center">
                                        <i class="card-title-icon fa-solid fa-chalkboard-user material-icon-fa me-2"
                                            aria-hidden="true"></i>
                                        <h2 class="dashboard-card-title">My Upcoming Workshops</h2>
                                    </div>
                                    <div class="col-md-2 d-none d-md-flex justify-content-end">
                                        <button class="btn btn-secondary w-100 fs-6" mdbRipple
                                            routerLink="/search-workshops">
                                            Search Workshops
                                        </button>
                                    </div>
                                </div>
                                <p class="dashboard-card-subtitle mt-1">View your registered workshops and cancel them
                                    if needed.</p>
                                <div class="d-md-none mt-2">
                                    <button class="btn btn-secondary w-100" mdbRipple routerLink="/search-workshops">
                                        Search Workshops
                                    </button>
                                </div>
                            </div>

                            <div class="card-body p-3">
                                @if (isLoading()) {
                                <div class="dashboard-empty-state">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading workshops...</span>
                                    </div>
                                </div>
                                } @else if (groupedWorkshops().length > 0) {
                                @for (group of groupedWorkshops(); track group[0]) {
                                <div class="col-12 col-md-11 col-xl-9  px-0 mx-auto">
                                    <div class="workshop-date">{{ group[0] }}</div>
                                </div>

                                @for (workshop of group[1]; track workshop.workshopSessionId) {
                                <!-- Width constraint wrapper -->
                                <div class="col-12 col-md-11 col-xl-9 mx-auto px-0">
                                    <div [class]="getWorkshopItemClass(workshop)">
                                        <div class="row align-items-center">

                                            <!-- Col 1: Status + Time & Location -->
                                            <div class="col-12 col-md-3 d-flex position-relative">
                                                <div class="flex-grow-1 mt-2 mb-2">

                                                    <!-- Status chip (always on its own line) -->

                                                    <div class="chip-outline mb-1 mx-3 w-auto"
                                                        [ngClass]="getRegisteredWorkshopStatusClass(workshop)">
                                                        {{ (getWorkshopFriendlyStatus(workshop) == 'Last Seats') ||
                                                        (getWorkshopFriendlyStatus(workshop) == 'Open') ? 'Scheduled' :
                                                        getWorkshopFriendlyStatus(workshop) | titlecase }}
                                                    </div>
                                                    <!-- Time + Room side by side on mobile, stacked on desktop -->
                                                    <div class="d-flex flex-wrap justify-content-between flex-md-column mx-3">
                                                        <div class="workshop-time">
                                                            <i class="fa-regular fa-clock material-icon-fa"
                                                                aria-hidden="true"></i>
                                                            {{ formatWorkshopTime(workshop.sessionStartDateTime) }}
                                                        </div>
                                                        <div class="workshop-time">
                                                            @if(formatWorkshopMode(workshop) == 'Online'){
                                                            <i class="fa-solid fa-globe material-icon-fa"
                                                                aria-hidden="true"></i>
                                                            } @else {
                                                            <i class="fa-solid fa-location-dot material-icon-fa"
                                                                aria-hidden="true"></i>
                                                            }
                                                            {{ workshop.room ?? formatWorkshopMode(workshop!) }}
                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="vr vr-blurry ms-3 d-none d-md-block"
                                                    style="height: auto; align-self: stretch;"></div>
                                            </div>

                                            <!-- Mobile divider -->
                                            <div class="col-12 d-md-none">
                                                <hr class="hr my-2">
                                            </div>

                                            <!-- Col 2: Workshop Name -->
                                            <div class="col-12 col-md-8">
                                                <div class="workshop-title text-center text-md-start">
                                                    {{ workshop.title }}
                                                </div>
                                                <div class="workshop-description d-none d-md-block">
                                                    {{workshop.description}}
                                                </div>

                                            </div>

                                            <!-- Mobile divider -->
                                            <div class="col-12 d-md-none my-2">

                                            </div>

                                            <!-- Col 3: View Button -->
                                            <div class="col-12 col-md-1">
                                                <div class="d-flex justify-content-center justify-content-md-end">
                                                    <button type="button" [mdbTooltip]="getWorkshopButtonText(workshop)"
                                                        [class]="this.isMobile() ? getWorkshopCardButtonClass(workshop) :  getWorkshopButtonClass(workshop)"
                                                        (click)="openModal(workshop)"
                                                        [attr.aria-label]="getWorkshopAriaLabel(workshop)">
                                                        <i [class]="getWorkshopButtonIcon(workshop)"
                                                            aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                }
                                }
                                } @else {
                                <div class="dashboard-empty-state  d-flex flex-column justify-content-center align-items-center"
                                    style="min-height: 400px;">
                                    <i class="fa-solid fa-chalkboard-user fa-3x material-icons" aria-hidden="true"></i>
                                    <div class="dashboard-empty-state-title">No Upcoming Workshops</div>
                                    <div class="dashboard-empty-state-message">
                                        You are not registered for any upcoming workshops. Search for available
                                        workshops to get started.
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <!-- My Workshop History -->
                <div class="row mb-4">
                    <div class="col-12">
                        <div class="card" #resultsCard>
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <i class="card-title-icon fa-solid fa-timeline material-icon-fa me-2"
                                        aria-hidden="true"></i>
                                    <h2 class="dashboard-card-title">My Workshop History</h2>
                                </div>
                                <p class="dashboard-card-subtitle mt-1">Browse and filter your past workshop attendance.
                                </p>

                            </div>
                            <div class="card-body">
                                @if (isLoading()) {
                                <div class="dashboard-empty-state">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading workshops...</span>
                                    </div>
                                </div>
                                }
                                @else if (workshopHistory().length > 0) {


                                <!-- Table -->
                                <div class="table-responsive">
                                    <div class="datatable">
                                        <table class="table datatable-table table-hover" mdbTable mdbTableSort
                                            [fixedHeader]="true" #table="mdbTable" #sort="mdbTableSort"
                                            [dataSource]="workshopHistory()" [sort]="sort" [pagination]="pagination"
                                            aria-label="Available Workshops">
                                            <thead class="datatable-header fw-bold fs-5">
                                                <tr>
                                                    @for (header of headers; track header.field) {
                                                    <th [mdbTableSortHeader]="header.field" scope="col">{{ header.label
                                                        }}</th>
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody class="datatable-body fs-6">
                                                @for (workshop of table.data; track workshop.workshopSessionId) {
                                                <!-- on mobile add attributes for screen readers -->
                                                <tr scope="row" class="align-middle"
                                                    [class.table-row-clickable]="isMobile()"
                                                    (click)="isMobile() && openModal(workshop)"
                                                    [attr.role]="isMobile() ? 'button' : null"
                                                    [attr.tabindex]="isMobile() ? '0' : null"
                                                    (keyup.enter)="isMobile() && openModal(workshop)">
                                                    <td class="fw-regular" [ngClass]="isMobile() ? 'date-text-wrap-balance': 'date-text-wrap'">{{formatWorkshopDateOnly(workshop.sessionStartDateTime)}}<br/>{{formatWorkshopTime(workshop.sessionStartDateTime)+ '-' + formatWorkshopTime(workshop.sessionEndDateTime)}}</td>
                                                    <td class="fw-regular">{{ workshop.topic }}</td>
                                                    <td class="fw-bold">{{ workshop.title }}</td>
                                                    <td class="fw-regular">{{ workshop.room }}</td>
                                                    <td class="fw-regular">{{ formatWorkshopMode(workshop) }}</td>
                                                    <td class="fw-regular">{{ workshop.language }}</td>
                                                    <td>
                                                        <div class="chip-outline position-relative"
                                                            [class]="getRegisteredWorkshopStatusClass(workshop)">
                                                       {{ (getWorkshopFriendlyStatus(workshop) == 'Last Seats') ||
                                                        (getWorkshopFriendlyStatus(workshop) == 'Open') ? 'Scheduled' :
                                                        getWorkshopFriendlyStatus(workshop) | titlecase }}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="row justify-content-center">
                                                            <div class="col-10 col-md-6">

                                                                <button type="button"
                                                                    [mdbTooltip]="getWorkshopButtonText(workshop)"
                                                                    [class]="getWorkshopButtonClass(workshop)"
                                                                    (click)="$event.stopPropagation(); openModal(workshop)"
                                                                    [attr.aria-label]="getWorkshopAriaLabel(workshop)">
                                                                    <i [class]="getWorkshopButtonIcon(workshop)"
                                                                        aria-hidden="true"></i>
                                                                </button>

                                                            </div>
                                                        </div>


                                                    </td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                        <mdb-table-pagination #pagination></mdb-table-pagination>
                                    </div>
                                </div>

                                }
                                @else {
                                <!-- Empty state -->
                                <div class="dashboard-empty-state  d-flex flex-column justify-content-center align-items-center"
                                    style="min-height: 400px;">
                                    <i class="fa-solid fa-chalkboard-user fa-3x material-icons" aria-hidden="true"></i>
                                    <div class="dashboard-empty-state-message">
No workshop history to display.
Past, completed, cancelled, and postponed workshops you have registered for will appear here.                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <!-- -->
                <div class="row">
                    <app-gradientsegmentbar></app-gradientsegmentbar>
                </div>
            </div>
            <div class="col-xxl-1"></div>
        </div>
    </div>
</div>